import { type ScatterNode } from '@mentimeter/visualizations';
import type { RatingT } from '@mentimeter/question-modules-types';

interface MapScatterNodesProps extends Pick<RatingT, 'results' | 'votes'> {
  barColors: string[];
}

export function mapScatterNodes({
  results,
  votes,
  barColors,
}: MapScatterNodesProps): ScatterNode[] {
  return results.flatMap((node, i) => {
    const vote = votes[node.id] ?? [];
    return vote.map<ScatterNode>((nodeVote) => ({
      ...node,
      vote: nodeVote ?? [],
      color: barColors[i]!,
    }));
  });
}
